import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../../config/authAxios";
import apiRoutes from "../../apiConfigs";

export const updateExternalLinkApi = createAsyncThunk(
  "auth/teacher-lounge/updateExternalLink",
  async (data, { rejectWithValue }) => {
    try {
      const { ID, ...rest } = data
      const response = await AuthAxios.patch(
        apiRoutes.adminAction(`events/external-links/${ID}`, 1),
        rest
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const updateExternalLinkSlice = createSlice({
  name: "updateExternalLink",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(updateExternalLinkApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateExternalLinkApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(updateExternalLinkApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const updateExternalLinkReducer = updateExternalLinkSlice.reducer;
